// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 221) return "js/dashboard/221.js";
	if (chunkId === 435) return "js/dashboard/435.js";
	if (chunkId === 856) return "js/dashboard/856.js";
	if (chunkId === 410) return "js/dashboard/410.js";
	// return url for filenames based on template
	return undefined;
};